  <nz-card style="margin-bottom: 10px;">
    <nz-spin [nzSpinning]="loading">
        <div>
      <form nz-form [formGroup]="validateForm" >
        <div class="条件区">
    
          <!-- 第一行 -->
          <div nz-row >
            <div nz-col nzSpan="2" *ngIf="ShowSite">
              <nz-form-label >
                <div class="width-100-percent label-font">
                  {{ "Site" | translate }}
                </div>
              </nz-form-label>
              <nz-form-item >
                <nz-form-control nz-col nzSpan="20">
                  <nz-select formControlName="Site" (ngModelChange)="valuehandleChange()" nzAllowClear    nzPlaceHolder="{{'ALL'|translate}}">
                    <nz-option *ngFor="let option of SiteList" [nzLabel]="option.siteName" [nzValue]="option.siteCode">
                    </nz-option>
                  </nz-select>
                </nz-form-control >
              </nz-form-item>
            </div>

            <div nz-col nzSpan="4"  *ngIf="ShowBuyer">
              <nz-form-label>
                <div class="width-100-percent label-font">
                  {{ "Buyer" | translate }}
                </div>
              </nz-form-label>
              <nz-form-item *ngIf="UserRequestlimits">
                <nz-form-control nz-col nzSpan="22">
                  <nz-select [nzServerSearch]="true" nzMode="multiple" formControlName="Buyer" nzShowSearch nzAllowClear  (nzOnSearch)="BuyerSearch($event)"
                    (ngModelChange)="valuehandleChange()" nzPlaceHolder="{{'ALL'|translate}}">
                      <nz-option *ngFor="let option of BuyerList" [nzLabel]="option.buyerName" [nzValue]="option.buyer"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            
            <div nz-col nzSpan="8" *ngIf="ShowVendor">
              <nz-form-label >
                <div class="width-100-percent label-font">
                  {{ "VendorName" | translate }}
                </div>
              </nz-form-label>
              <nz-form-item *ngIf="UserRequestlimits">
                <nz-form-control nzSpan="24">
                  <nz-select [nzServerSearch]="true" nzMode="multiple" formControlName="Vendor" nzShowSearch nzAllowClear nzPlaceHolder="{{'ALL'|translate}}"
                    (ngModelChange)="valuehandleChange()"    (nzOnSearch)="VendorSearch($event)">
                      <nz-option *ngFor="let option of VendorList" [nzLabel]="option.vendorName"
                        [nzValue]="option.vendorCode"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>

          </div>
          <!-- 第二行 -->
          <div nz-row class="row-with-spacing">

 
            <div nz-col nzSpan="4" *ngIf="ShowType">
              <nz-form-label >
                <div class="width-100-percent label-font">
                  {{ "PoType" | translate }}
                </div>
              </nz-form-label>
              <nz-form-item *ngIf="UserRequestlimits">
                <nz-form-control nzSpan="22">
                  <nz-select nzMode="multiple" formControlName="Type" nzShowSearch nzAllowClear [nzLoading]="true"  [nzMaxTagPlaceholder]="maxTagPlaceholder" [nzMaxTagCount]="1"
                 (ngModelChange)="valuehandleChange()" >
                 <ng-template #maxTagPlaceholder let-selectedOptions >
                  <span class="selected-labels" [title]="selectedLabels.join('\n')">+ {{ selectedOptions.length}}</span>
                </ng-template>
                <nz-option *ngFor="let option of options" [nzLabel]="option.nzLabel" [nzValue]="option.nzValue"></nz-option>
                  </nz-select>
                </nz-form-control>

              </nz-form-item>
            </div>

            <div nz-col nzSpan="4" *ngIf="ShowType">
              <nz-form-label nzSpan="22">
                <div class="width-100-percent label-font">{{ "PoNo" | translate}}
                </div>
              </nz-form-label>
              <nz-form-control nzSpan="22">
                <input nz-input formControlName="PONO"  (ngModelChange)="valuehandleChange()"/>
              </nz-form-control>
            </div>

            <div nz-col nzSpan="4" *ngIf="ShowPRNO">
              <nz-form-label nzSpan="22">
                <div class="width-100-percent label-font">{{ "PRNO" | translate}}
                </div>
              </nz-form-label>
              <nz-form-control nzSpan="22">
                <input nz-input formControlName="PRNO"  (ngModelChange)="valuehandleChange()"/>
              </nz-form-control>
            </div>  

            <div nz-col nzSpan="4" *ngIf="ShowPOApprovedate">
              <nz-form-label nzSpan="22">
                <div class="width-100-percent label-font">{{ "PoDate" | translate}}
                </div>
              </nz-form-label>
              <nz-form-control nzSpan="22">
                <nz-range-picker [nzFormat]="dateFormat" nzPlaceHolder='' formControlName="POApprovedate" (ngModelChange)="valuehandleChange()"></nz-range-picker>
              </nz-form-control>
            </div>    

            <div nz-col nzSpan="4" *ngIf="ShowPRNO">
              <nz-form-label nzSpan="22">
                <div class="width-100-percent label-font">{{ "RTorNot" | translate}}
                </div>
              </nz-form-label>
              <nz-form-control nzSpan="22">
                <nz-select formControlName="RTorNot" nzAllowClear (ngModelChange)="valuehandleChange()">
                  <nz-option nzLabel="{{'ALL'|translate}}" nzValue=""></nz-option>
                  <nz-option nzLabel="{{'NO'|translate}}" nzValue="0"></nz-option>
                  <nz-option nzLabel="{{'YES'|translate}}" nzValue="1"></nz-option>
                </nz-select>
              </nz-form-control>
            </div>    


            <div nz-col   class="row-with-spacing-button">
              <button nz-button nzType="primary" class="default-button" (click)="onPageChangeQuery()">
                <span nz-icon nzType="search">
              </span>
              {{ "Query" | translate}}
              </button>
            </div>

            <div nz-col   class="row-with-spacing-button"*ngIf="ShowSecondDownloadExcel">
              <button nz-button nzType="primary" class="default-button" (click)="onPageChangeDownload()">
                <span nz-icon nzType="download" nzTheme="outline"></span>
                {{'DownloadExcel'|translate}}
              </button>
            </div>

            <div nz-col class="row-with-spacing-button"*ngIf="ShowSecondExport">
              <button nz-button nzType="primary" class="default-button" (click)="onPageChangeDownload()">
                <span nz-icon nzType="export" nzTheme="outline"></span>
                {{'Export'|translate}}
              </button>
            </div>

            <div nz-col class="row-with-spacing-button"  *ngIf="ShowUpload">
              <nz-upload   [nzBeforeUpload]="beforeUpload" >
              <button  nz-button nzType="primary" class="default-button"  >
                <span nz-icon nzType="upload" nzTheme="outline"></span>
                {{'UploadExcel'|translate}}
              </button>
            </nz-upload>
            </div>


          </div>
        </div>
      </form>
  
    </div>
  </nz-spin>
</nz-card>

